// Short platform names for the grid columns. Studies record the full product
// name ("SomaScan 7k", "Olink Target 96 Cardiometabolic", "Meso Scale
// Discovery"); a column only needs the family, and the full names stay in the
// cell's tooltip.

export function shortPlatformName(name) {
  const s = String(name || '').trim();
  if (/^somascan/i.test(s)) return 'SomaScan';
  if (/^olink/i.test(s)) return 'Olink';
  if (/^meso\s*scale/i.test(s) || /^msd$/i.test(s)) return 'MSD';
  return s;
}

// A list (array or comma-separated string) as unique short names, in order.
export function shortPlatformList(platforms) {
  const items = Array.isArray(platforms)
    ? platforms
    : String(platforms || '').split(',');
  const out = [];
  for (const item of items) {
    const short = shortPlatformName(item);
    if (short && !out.includes(short)) out.push(short);
  }
  return out.join(', ');
}

// One-line descriptions of the platform families, for legends and help text.
// Listed in this order wherever they are shown.
export const PLATFORM_DESCRIPTIONS = {
  SomaScan: 'SomaLogic aptamer-based affinity assay measuring a predefined panel of thousands of proteins (e.g. SomaScan 7k).',
  MS: 'Mass spectrometry: untargeted proteomics that identifies proteins from their measured peptides.',
  Olink: 'Proximity extension assay: pairs of DNA-tagged antibodies read out by PCR; here the Target 96 Cardiometabolic panel of 92 proteins.',
  MSD: 'Meso Scale Discovery: electrochemiluminescence sandwich immunoassays measuring one or a few selected proteins per kit.',
};
